const keys = [
	{
		path: '/agency/keys/types/list',
		name: 'agency-keys-types-list',
		component: () => import('@/views/agency/keys/keys-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/content-type/list',
		name: 'agency-keys-contents-list',
		component: () => import('@/views/agency/keys/keys-contents/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/status/list',
		name: 'agency-keys-status-list',
		component: () => import('@/views/agency/keys/keys-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/suppliers/list',
		name: 'agency-keys-suppliers-list',
		component: () => import('@/views/agency/keys/keys-suppliers/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/suppliers-prs/list',
		name: 'agency-keys-suppliers-prs-list',
		component: () => import('@/views/agency/keys/keys-suppliers-prs/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/keys/list',
		name: 'agency-keys-list',
		component: () => import('@/views/agency/keys/keys/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/keys-items/:id',
		name: 'agency-keys-items-list',
		component: () =>
			import(/* webpackChunkName: "ApisListCredentials" */ '@//views/agency/keys/keys-items/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/requests/list',
		name: 'agency-keys-requests-list',
		component: () => import('@/views/agency/keys/keys-requests/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/keys-requests-status/list',
		name: 'agency-keys-requests-status-list',
		component: () => import('@/views/agency/keys/keys-requests-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/materials',
		name: 'agency-keys-materials-global',
		component: () =>
			import(/* webpackChunkName: "ApisListCredentials" */ '@//views/agency/keys/keys-materials/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		path: '/agency/keys/keys-materials/:id',
		name: 'agency-keys-materials-list',
		component: () =>
			import(/* webpackChunkName: "ApisListCredentials" */ '@//views/agency/keys/keys-materials/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
	{
		// Was under the generic Mail Hub menu (/mail/key-requests-studio,
		// name mail-hub-key-requests-studio) even though it's an
		// Agency-specific workflow — editorial staff requesting review keys
		// directly from a game's studio. Same gate as every other key
		// screen in this file.
		path: '/agency/keys/ask-studio',
		name: 'agency-keys-ask-studio',
		component: () => import(/* webpackChunkName: "AgencyKeyRequestsStudio" */ '@/views/agency/keys/key-requests-studio/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,keys',
		},
	},
]

export default keys
